<template>
  <div class="text-2sm text-text-muted w-12 mr-6">
    {{ $moment.unix(date).format(dateFormat) }}
  </div>
</template>

<script>
export default {
  name: "Time",
  props: {
    date: {
      type: Number,
      required: true
    },
    dateFormat: {
      type: String,
      default: 'HH:mm'
    }
  }
}
</script>